import React from "react";
import ProjectList from "./projects/ProjectList";
import TeamList from "./teams/TeamList";

const Sidebar = () => {
  return (
    <div className="sidebar">
      {/* Projects List */}
      <ProjectList />
      {/* Team Members */}
      <TeamList />
    </div>
  );
};

export default Sidebar;
